import axios from 'axios';
export const API = axios.create({ baseURL: process.env.REACT_APP_BASE_URI });
// API.interceptors.request.use(
//     function (config) {
//       return config;
//     },
//     function (error) {
//       return Promise.reject("Resuest Error",error);
//     }
//   );
  
//   API.interceptors.response.use(
//     function (response) {
//       return response;
//     },
//     function (error) {
//       return Promise.reject("response errorr",error);
//     }
//   );
  